import baseHttpService from "core/http/singleton/base";
import { getBannerURL } from "./urls";
import { getImageRes } from "../personnelInformation/resTypes";

export const getBannerApi = async (): Promise<getImageRes> => {
  const res = await baseHttpService.get<getImageRes>(getBannerURL);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
